
import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';
import { Padder } from '../../eucalyptus/Spacings';
import WebText from '../../eucalyptus/Text/Text.vue';
import { Grid, Column } from '../../eucalyptus/Grid';

/**
 * Contact Us Component.
 *
 * Grid List of Contact Us.
 */
export default Vue.extend({
  name: 'Contacts',
  components: {
    Padder,
    WebText,
    Column,
    Grid
  },
  props: {
    /**
     * The icon Height of the Contact Us.
     */
    iconHeight: {
      type: String,
      default: '20px'
    },
    /**
     * List of Contact.<br />
     * Model of the list:
     *
     * - id: Unique identifier of list.
     * - title: The title of the Contact, eg: `Whatsapp`.
     * - desc: Description of the Contact.
     * - img: URL image of the Contact.
     */
    contactContents: {
      type: Array,
      default: () => [
        {
          id: 1,
          title: 'Whatsapp',
          desc: 'Whatsapp Desc',
          img: 'https://qoala.app/_nuxt/img/67462de.png'
        },
        {
          id: 2,
          title: 'Chat',
          desc: 'Chat Desc',
          img: 'https://qoala.app/_nuxt/img/5a1d2f2.png'
        },
        {
          id: 3,
          title: 'Email',
          desc: 'Email Desc',
          img: 'https://qoala.app/_nuxt/img/9ebc088.png'
        },
        {
          id: 4,
          title: 'Call',
          desc: 'Call Desc',
          img: 'https://qoala.app/_nuxt/img/03dc95b.png'
        }
      ]
    }
  },
  computed: {
    computedHeightIcon() {
      if (this.iconHeight) {
        return `height: ${this.iconHeight}`;
      }
      return `height: 20px`;
    }
  },
  methods: {
    computedBorder(id: any) {
      if (id !== this.contactContents.length) {
        return `border-right: 0.5px solid rgb(202, 228, 238);`;
      }
      return ``;
    },
    onCustomerServiceClick(title: string) {
      /**
       * Handle when a Contact is clicked
       * @event handle-contacts
       * @type {function}
       */
      this.$emit('handle-contacts', title);
    }
  }
});
